import { getCdrService } from "@ntconnect/framework/pbx";

export const fetchPbxCdrs = (domain, extension, page, pageSize, search, filter) =>
  getCdrService().fetchCdrs(domain, extension, page, pageSize, search, filter);
